import fetchLicenseStats from './FetchLicenseStats'

const SET_STATS = 'SET_STATS'
const RESET_DATA = 'RESET_DATA'
const SET_CURRENT_ORG = 'SET_CURRENT_ORG'

const POLLING_INTERVAL_IN_SECONDS = 5 * 1000
const VIEW_PERMISSION = 'view license information'

let intervalId = null

export default {
    namespaced: true,

    state: {
        purchasedCount: null,
        usedCount: null,
        currentOrganizationSlug: null,
    },

    getters: {
        purchasedCount(state) {
            return state.purchasedCount
        },

        usedCount(state) {
            return state.usedCount
        },

        userHasPermission(state, getters, rootState, rootGetters) {
            return state.currentOrganizationSlug && rootGetters.hasPermission(VIEW_PERMISSION)
        },
    },

    mutations: {
        [SET_STATS](state, { purchasedCount, usedCount }) {
            state.purchasedCount = purchasedCount
            state.usedCount = usedCount
        },

        [RESET_DATA](state) {
            state.purchasedCount = null
            state.usedCount = null
            state.currentOrganizationSlug = null
        },

        [SET_CURRENT_ORG](state, currentOrganizationSlug) {
            state.currentOrganizationSlug = currentOrganizationSlug
        },
    },

    actions: {
        async forceRefresh({ dispatch }) {
            dispatch('disablePolling')
            await dispatch('enablePolling')
        },

        async enablePolling({ commit, state, getters }) {
            const { currentOrganizationSlug } = state
            if (!intervalId && getters.userHasPermission) {
                const internalFetch = async () => {
                    if (intervalId) {
                        await fetchLicenseStats(currentOrganizationSlug, (purchasedCount, usedCount) => {
                            commit(SET_STATS, {
                                purchasedCount,
                                usedCount,
                            })
                        })
                    }
                }

                // schedule polling
                intervalId = window.setInterval(async () => {
                    await internalFetch()
                }, POLLING_INTERVAL_IN_SECONDS)

                // fetch now
                await internalFetch()
            }
        },

        disablePolling({ commit, state }) {
            if (intervalId) {
                window.clearInterval(intervalId)
                intervalId = null
            }
        },

        reset({ commit, dispatch }) {
            dispatch('disablePolling')
            commit(RESET_DATA)
        },

        // subscribe to actions from auth store

        identityUpdated: {
            root: true,
            async handler({ commit, dispatch, rootState, state }) {
                if (!rootState.auth.user || !rootState.auth.organization) {
                    dispatch('reset')
                } else if (!rootState.auth.organization.slug !== state.currentOrganizationSlug) {
                    dispatch('reset')
                    commit(SET_CURRENT_ORG, rootState.auth.organization.slug)
                    await dispatch('enablePolling')
                }
            },
        },
    },
}
